<template functional>
  <v-progress-circular
    indeterminate
    :size="74"
    :width="4"
    color="accent"
    :class="{ 'progress-circular--hide': !props.loading }"
  >
    <v-btn
      fab
      :type="props.type"
      @click="listeners.click || null"
      color="primary"
      :dark="!props.loading"
      :light="props.loading"
      :disabled="props.loading"
    >
      <slot></slot>
    </v-btn>
  </v-progress-circular>
</template>

<script>
export default {
  name: 'ProgressBtn',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'button',
    },
  },
};
</script>

<style scoped>
  .v-progress-circular {
    left: 50%;
    bottom: 0;
    position: absolute;
    transform: translate(-50%, 50%);
  }
</style>

<style>
  .progress-circular--hide svg {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProgressBtn.vue